import { render, staticRenderFns } from "./ItemListPerPage.vue?vue&type=template&id=130694a0&"
import script from "./ItemListPerPage.vue?vue&type=script&lang=js&"
export * from "./ItemListPerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kael-cadranel/Sites/apps.chateaudeseneffe.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130694a0')) {
      api.createRecord('130694a0', component.options)
    } else {
      api.reload('130694a0', component.options)
    }
    module.hot.accept("./ItemListPerPage.vue?vue&type=template&id=130694a0&", function () {
      api.rerender('130694a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ItemListPerPage.vue"
export default component.exports